export const MENU_SET_ITEMS = 'MENU_SET_ITEMS';
